import React, { useState, useEffect } from 'react';

const loadingMessages = [
  "Dispatching elite space engineers...",
  "Summoning Pokémon professors...",
  "Consulting with Professor Oak...",
  "Scanning Pokédex database...",
  "Calibrating Poké Ball systems...",
  "Synchronizing with Pokémon Centers...",
  "Charging up Master Balls...",
  "Activating Rare Candy protocols...",
  "Connecting to Bill's PC...",
  "Powering up evolution stones...",
  "Gathering wild Pokémon data...",
  "Initializing trading system..."
];

export default function LoadingHeader() {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex(current => (current + 1) % loadingMessages.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center gap-3">
      <div className="h-8 w-8 relative">
        <div className="absolute inset-0 border-2 border-white/20 border-t-white/60 rounded-full animate-spin" />
      </div>
      <div className="text-white/60 min-w-[200px] transition-all duration-200">
        {loadingMessages[messageIndex]}
        <span className="inline-flex ml-1">
          <span className="animate-pulse">.</span>
          <span className="animate-pulse delay-100">.</span>
          <span className="animate-pulse delay-200">.</span>
        </span>
      </div>
    </div>
  );
}